<template>
  <div :class="bindSubscriptCls">
    <div :class="bindTopIconsCls" v-if="topIconsMsg">
      <span class="spa-1">{{ topIconsMsg }}</span>
      <span class="spa-2"></span>
    </div>
    <div
      :class="bindBomIconsCls"
      v-if="scriptConfig.subscriptDesc"
      :style="bottomBackColor"
    >
      <span>{{ scriptConfig.subscriptDesc }}</span>
    </div>
  </div>
</template>
<script>
  import { moneyFormatRules } from '@/utils/moneyFormatRules'
  import { mapState, mapGetters } from 'vuex'

  export default {
    props: {
      scriptConfig: {
        type: Object,
        default: function () {
          return {
            discountType: '',
            superscriptDesc: '',
            superscriptColor: '',
            subscriptDesc: '',
            subscriptColor: '',
          }
        },
      },
    },
    components: {},
    computed: {
      ...mapState(['region', 'isMobile', 'isDesktop', 'currency']),
      ...mapGetters(['displayModeClassName', 'displayHorizontal']),
      symbolInAfter() {
        return moneyFormatRules.SymbolInAfter
      },
      // 上角标展示
      topIconsMsg() {
        const { discountType = '', superscriptDesc = '' } = this.scriptConfig

        const fPrice = this.$options.filters['formatMoney'](
          Number(superscriptDesc)
        )

        const disprice = this.symbolInAfter
          ? `${fPrice} ${this.currency} OFF`
          : `${this.currency} ${fPrice} OFF`

        const datas = {
          1: `${superscriptDesc} OFF`,
          2: disprice,
          3: '',
        }
        return datas[Number(discountType)] || datas[3]
      },
      bottomBackColor() {
        if (this.isDesktop) return {}
        return {
          backgroundColor: this.scriptConfig?.subscriptColor || '',
        }
      },
      bindTopIconsCls() {
        let defaults = ['top-icons']
        const { superscriptColor = '1' } = this.scriptConfig
        defaults.push(`${defaults[0]}-type${superscriptColor}`)
        return defaults
      },
      bindBomIconsCls() {
        let defaults = ['bottom-icons']
        if (this.isDesktop) {
          const { superscriptColor = '1' } = this.scriptConfig
          defaults.push(`${defaults[0]}-type${superscriptColor}`)
        }

        return defaults
      },
      bindSubscriptCls() {
        let defaults = ['subscript']
        if (this.isDesktop) {
          defaults.push(`${defaults[0]}-desktop`)
        } else {
          defaults.push(`${defaults[0]}-mobile`)
        }
        return defaults
      },
    },
  }
</script>
<style lang="scss" scoped src="./styles.scss"></style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    @import './styles_pc.scss';
  }
</style>
